import React, { useState } from "react";
import { CaretDown, Check } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const ITEM = "flex items-center gap-2 text-xs cursor-pointer rounded-none data-[selected=true]:bg-black data-[selected=true]:text-white";

export const SearchSelect = ({ value, onChange, options, allLabel, placeholder, testId }) => {
  const [open, setOpen] = useState(false);
  const current = options.find((o) => o.value === value);
  const pick = (v) => { onChange(v); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
                className="border-2 border-black px-2 py-1.5 text-xs bg-white w-full flex items-center justify-between gap-2 text-left hover:bg-zinc-50 transition-colors">
          <span className="truncate">{current ? current.label : allLabel}</span>
          <CaretDown size={11} weight="bold" className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-72 border-2 border-black rounded-none shadow-[4px_4px_0_#000]" align="start">
        <Command>
          <CommandInput placeholder={placeholder} className="text-xs" data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty className="py-4 text-center text-xs text-zinc-500">No matches</CommandEmpty>
            <CommandGroup>
              <CommandItem value={`__all__ ${allLabel}`} onSelect={() => pick("")} className={ITEM} data-testid={`${testId}-option-all`}>
                <Check size={12} weight="bold" className={value ? "opacity-0" : "opacity-100"} /> {allLabel}
              </CommandItem>
              {options.map((o) => (
                <CommandItem key={o.value} value={`${o.label} ${o.value}`} onSelect={() => pick(o.value)}
                             className={ITEM} data-testid={`${testId}-option-${o.value}`}>
                  <Check size={12} weight="bold" className={o.value === value ? "opacity-100" : "opacity-0"} />
                  <span className="truncate">{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
